import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AdminUsers() {
    const [users, setUsers] = useState([]);
    useEffect(() => {
        api.get("/admin/users").then((r) => setUsers(r.data));
    }, []);
    return (
        <div className="p-8" data-testid="admin-users">
            <h1 className="font-display text-3xl font-bold mb-1">Users</h1>
            <p className="text-sm text-muted-foreground mb-8">{users.length} registered</p>
            <div className="bg-white border border-border overflow-x-auto">
                <table className="w-full text-sm">
                    <thead className="bg-muted text-left"><tr>
                        <th className="px-4 py-3">Name</th><th className="px-4 py-3">Email</th><th className="px-4 py-3">Phone</th><th className="px-4 py-3">Role</th><th className="px-4 py-3">Joined</th>
                    </tr></thead>
                    <tbody>
                        {users.map((u) => (
                            <tr key={u.id} className="border-t border-border">
                                <td className="px-4 py-3 font-semibold">{u.name}</td>
                                <td className="px-4 py-3">{u.email}</td>
                                <td className="px-4 py-3">{u.phone || '—'}</td>
                                <td className="px-4 py-3"><span className={`px-2 py-0.5 text-[10px] uppercase tracking-wider ${u.role === 'admin' ? 'bg-primary text-white' : 'bg-muted'}`}>{u.role}</span></td>
                                <td className="px-4 py-3 text-xs text-muted-foreground">{new Date(u.created_at).toLocaleDateString()}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
